import { useEffect } from "react";
import Strings from "../../utils/Strings";
import Testimonials1 from "../../Assets/Testimonials1.jpeg";
import Testimonials2 from "../../Assets/gallery6.JPG";
import Testimonials3 from "../../Assets/gallery8.jpeg";
import Testimonials4 from "../../Assets/gallery9.jpeg";

import Footer from "../../Components/Footer/Footer";

const Testimonials = () => {
  const videoData = [
    "https://blr1.digitaloceanspaces.com/vmb-2.0-dev-bucket/media/photologue/photos/MQ%20NLD%20&%20PBDD_2025-08-21T11-30-38-961Z.mp4",

    "https://blr1.digitaloceanspaces.com/vmb-2.0-dev-bucket/media/photologue/photos/MQ%20AGSD%20&%20GPD_2025-08-21T11-32-51-683Z.mp4",

    "https://blr1.digitaloceanspaces.com/vmb-2.0-dev-bucket/media/photologue/photos/MQ%20VRD%20&%20PGDD%20subtitles&photos_2025-08-21T11-34-34-804Z.mp4",
  ];
  const testimonials = [
    {
      id: 1,
      name: "Gunograhi and brindavaneswari",
      image: Testimonials1,
      text: Strings.USER_ONE,
      text1: Strings.USER_ONE_SPILT,
    },
    {
      id: 2,
      name: "Ys Tustatma Gourahari and Subhasini Lakshmipriya devi",
      image: Testimonials2,
      text: Strings.USER_TWO,
    },
    {
      id: 3,
      name: "Anantasesa Balabhadra Das and Deepapriya Gandharvika Devi Dasi",
      image: Testimonials3,
      text: Strings.USER_Three,
      text1: Strings.USER_THREE_SPILT,
    },
    {
      id: 3,
      name: "Mainak Dafadar and Yuthika",
      image: Testimonials4,
      text: Strings.USER_Three,
      text1: Strings.USER_THREE_SPILT,
      marriageDate: "May 03, 2026",
    },
  ];
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className="font-jost px-4 md:px-8 lg:px-16">
        <div className="py-7 pt-20 text-3xl md:text-4xl">
          <p className="text-center">Testimonials</p>
          <div className="mx-auto mt-2 w-11 border-b-2 border-yellow-400"></div>
        </div>

        <div className="flex flex-col gap-6 md:gap-8 lg:gap-10">
          {testimonials.length > 0 ? (
            testimonials.map((testimonial) => (
              <TestimonialCard key={testimonial.id} data={testimonial} />
            ))
          ) : (
            <p className="text-center text-yellow-700">
              No testimonials available at the moment.
            </p>
          )}
        </div>
        <div className="py-7 pt-20 text-3xl md:text-4xl">
          <p className="text-center">How the Questionnaire Helped?</p>
          <div className="mx-auto mt-2 w-11 border-b-2 border-yellow-400"></div>
        </div>
        <div className="grid grid-cols-1 gap-4 pb-10 pl-5 pr-5 md:grid-cols-2">
          {videoData.map((video, index) => (
            <div
              key={index}
              className="rounded-xl bg-yellow-400 pl-2 pr-2 pt-2 shadow-md transition-all hover:shadow-xl "
            >
              <video
                controls
                className="mb-3 h-80 w-full rounded-md border border-gray-300 object-cover"
              >
                <source src={video} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          ))}
        </div>
      </section>
      <div className="pt-10">
        <Footer />
      </div>
    </>
  );
};

const TestimonialCard = ({ data }) => {
  return (
    <div className="flex flex-col items-center gap-6 rounded-lg bg-yellow-400 p-6 shadow-md md:flex-row">
      <div className="flex-shrink-0">
        <img
          src={data.image}
          alt={data.name}
          className="h-40 w-40 rounded-full border-4 border-yellow-100 object-cover md:h-60 md:w-60"
        />
      </div>

      <div className="flex flex-col">
        {/* Quote */}
        <div className="relative mt-2 text-justify leading-relaxed text-black">
          <span className="absolute left-[-8px] top-[-18px] font-noto text-5xl text-yellow-800">
            “
          </span>
          <p className="rounded p-2 align-top  text-sm md:text-base">
            {data.text}
          </p>
          <p className="rounded p-2 align-top  text-sm md:text-base">
            {data.text1}
          </p>

          <span className="relative left-[4px] top-[-2px] font-noto text-5xl text-yellow-800">
            ”
          </span>
        </div>

        <div className="flex w-full items-center justify-between ">
          <p className="text-lg text-yellow-800 md:text-xl">- {data.name}</p>
          {data?.marriageDate && (
            <p className="text-lg text-yellow-800 md:text-xl">
              Marriage Date : {data?.marriageDate}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
